<template>
	<inertia-head title="User Materials" />
	<div class="bg-primary">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">User Material Management</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm">
						Manage user's materials
					</h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content">
		<div class="block border-bottom mb-0">
			<div class="block-content">
				<form @submit.prevent="changeActiveComponent">
					<div class="row">
						<div class="col-md-3 mb-4">
							<div class="form-group">
								<select v-model="form.category" class="form-select">
									<option value="">SELECT CATEGORY</option>
									<option
										v-for="(category, key, index) in $page.props.collection
											.material_categories"
										:key="category"
										:value="key"
									>
										{{ category }}
									</option>
								</select>
							</div>
						</div>
						<div class="col space-x-1 mb-4">
							<button
								type="submit"
								class="btn btn-secondary"
								:disabled="!form.isDirty || form.processing"
							>
								<i class="fa fa-search me-1"></i>Display
							</button>
							<button
								@click="add_new_material"
								type="button"
								class="btn btn-info"
							>
								<i class="fa fa-plus me-1"></i>Add new material
							</button>
						</div>
					</div>
				</form>
			</div>
		</div>
		<div v-if="materials.data.length > 0">
			<div
				v-for="(material, index) in materials.data"
				:key="`material-${material.id}`"
				:id="`material-${material.id}`"
				class="block mb-1"
			>
				<div class="block-content">
					<h6 class="mb-1">
						<small>
							{{ index + materials.from + '. ' + material.title }}
						</small>
					</h6>
					<div class="fs-sm fw-normal text-muted mb-2">
						<span class="me-3">
							<i class="fa fa-fw fa-calendar-alt opacity-50 me-1"></i>
							{{ material.date_created }}
						</span>
						<span class="me-3">
							<i class="fa fa-fw fa-tag opacity-50 me-1"></i>
							{{ material.date_appear_formatted }}
						</span>
						<div class="form-check form-switch form-check-inline">
							<input
								class="form-check-input"
								type="checkbox"
								:value="material.status"
								:id="material.id"
								name="example-switch-inline1"
								:checked="material.status"
								@change="toggle_status"
							/>
							<label class="form-check-label" for="example-switch-inline1">
								{{ material.status ? 'ACTIVE' : 'HIDDEN' }}
							</label>
						</div>
					</div>
				</div>
				<div
					class="block-content block-content-full block-content-sm bg-body-light fs-sm space-x-1"
				>
					<button
						@click="showMaterial(material, 'edit')"
						type="button"
						class="btn btn-alt-info btn-sm"
					>
						<i class="fa fa-pencil-alt me-1"></i>Edit
					</button>
					<button
						@click="confirmDelete(index)"
						type="button"
						class="btn btn-alt-danger btn-sm"
					>
						<i class="fa fa-times me-1"></i>Delete
					</button>
					<button
						@click="showMaterial(material, 'view')"
						type="button"
						class="btn btn-alt-primary btn-sm"
					>
						<i class="fa fa-search me-1"></i>View
					</button>
				</div>
			</div>
			<!-- Pagination -->
			<pagination :collections="materials" class="mt-5" />
		</div>
		<div v-else class="alert alert-warning">
			<p class="mb-0 fw-semibold">NO MATERIAL FOUND.</p>
		</div>

		<AddNewMaterialModal
			key="addNewMaterialModal"
			size="modal-xl"
			ref="addNewMaterialModal"
			:collection="collection"
		/>
		<ViewMaterialModal
			key="viewMaterialModal"
			ref="viewMaterialModal"
			:material="material"
		/>
		<EditMaterialModal
			key="editMaterialModal"
			size="modal-xl"
			ref="editMaterialModal"
			:collection="collection"
			:material="material"
		/>

		<modal ref="deleteModal">
			<template #title>DELETE CONFIRMATION</template>
			<template #body>
				<div class="text-center">
                    <p class="h6">
                        Are you sure, you want to delete this Email Swipe?
                    </p>
                </div>
			</template>
			<template #footer>
				<button type="button" @click="deleteMaterial()" class="btn btn-alt-primary btn-sm"><i class="fa fa-check-circle"></i> YES</button>
                <button @click="deleteModal.toggleModal" type="button" id="btnDeleteClose" class="btn btn-alt-danger btn-sm"><i class="fa fa-times-circle"></i> NO</button>
			</template>
		</modal>

	</div>
</template>

<script>
import AuthLayout from '../../../../Layouts/AuthLayout'
export default { layout: AuthLayout }
</script>

<script setup>
import { onMounted, ref, watch } from 'vue'
import { Inertia } from '@inertiajs/inertia'
import { useForm } from '@inertiajs/inertia-vue3'
import EditMaterialModal from '../../../../Components/Admin/SiteManagement/EditMaterialModal'
import ViewMaterialModal from '../../../../Components/Admin/SiteManagement/ViewMaterialModal'
import AddNewMaterialModal from '../../../../Components/Admin/SiteManagement/AddNewMaterialModal'
import { createToaster } from '@meforma/vue-toaster';

onMounted(() => {
	const pageContainer = document.getElementById('page-container')
	if (pageContainer.classList.contains('sidebar-o-xs'))
		pageContainer.classList.remove('sidebar-o-xs')
})

const props = defineProps({
	flash: Object,
	materials: Object,
	collection: Object,
	activeComponent: String,
	api_response	: Object
})

const toast 				= createToaster();

const action 				= ref('add');
const cur_index 			= ref(null);

const addNewMaterialModal 	= ref(null)

const viewMaterialModal 	= ref(null)

const editMaterialModal 	= ref(null)

const deleteModal 			= ref(null)

const material 				= ref(null)

const add_new_material = () => {
	action.value = "add";
	addNewMaterialModal.value.toggleModal()
}

const form = useForm({
	category: props.activeComponent,
})

const changeActiveComponent = () => {
	form.get(route('admin.site-management.user-materials.index'))
}

const showMaterial = (row, _action) => {
	action.value = "update";
	if (row) {
		material.value = row
		if (_action === 'view') {
			viewMaterialModal.value.toggleModal()
		} else {
			editMaterialModal.value.toggleModal()
		}
	}
}

const confirmDelete = (_index) => {
	// if (confirm('Are you sure to delete this material?')) {
	// 	Inertia.post(
	// 		route('admin.site-management.user-materials.destroy', id),
	// 		{ _method: 'DELETE' },
	// 		{
	// 			preserveState: true,
	// 			preserveScroll: true,
	// 			only: ['flash'],
	// 		}
	// 	)
	// }

	cur_index.value = _index;
	deleteModal.value.toggleModal();
}

const deleteMaterial = () => {
						action.value = "delete";
						var id = props.materials.data[cur_index.value].id;

						Inertia.post(
							route('admin.site-management.user-materials.destroy', id),
							{ _method: 'DELETE' },
							{
								preserveState: true,
								preserveScroll: true,
								only: ['materials','api_response'],
								onSuccess: () => {
									deleteModal.value.toggleModal();
								}
							}
						)
						// Inertia.delete('user-materials/'+id, {
						// 	preserveState: true,
						// 	preserveScroll: true,
						// 	only:['emailSwipes,api_response'],
						// 	onSuccess: () => {
						// 		deleteModal.value.toggleModal();
						// 	},
						// })
					}

// watch(
// 	() => props.flash,
// 	(flash) => {
// 		if (flash) {
// 			if (flash.animation) {
// 				const target = document.getElementById(
// 					'material-' + flash.animation.target
// 				)
// 				target.classList.remove('slideInUp')
// 				target.classList.add(flash.animation.class)
// 				// setTimeout(() => {
// 				// 	Inertia.reload({ only: ['materials'] })
// 				// }, 10)
// 			}
// 		}
// 	}
// )

watch(()=>props.api_response, (value) => {
			
	if(value!=null)
	{
		var action_msg = action.value=='add' ? 'added' : (action.value=='delete' ? 'deleted' : 'updated');

		if(value.result=="success")
		{
			toast.show("Successfully "+action_msg, { type: value.result});
		}else
		{
			toast.show("Failed to "+action_msg, { type: "error"});
		}
	}
})

</script>
